import { t } from 'i18next';
import { ILanguage } from 'services/enums/types';
import { ITitle } from 'services/types';

export const getLanguageSelectOptions = (
  languages?: ILanguage[],
  selectedTitles: ITitle[] = []
) => {
  const selectedLanguages = selectedTitles.map(({ language }) => language);

  const filteredLanguages = languages
    ?.map(l => ({ value: l.id, label: t(`enum.LANGUAGE.${l.id}`) }))
    .filter(option => !selectedLanguages.includes(option.value));

  return filteredLanguages;
};
